module.exports = __webpack_public_path__ + "fonts/0807de3.ttf";